// menu.resolver.ts
import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {GraphQlService} from './graphQL/graph-ql.service';

@Injectable({providedIn: 'root'})
export class MenuResolver implements Resolve<any> {
  constructor(private graphQlService: GraphQlService) {
  }

  resolve() {
    // ensure menus are filtered before component loads
    const user = JSON.parse(localStorage.getItem('pulse-right') || null);
    const moduleNames = JSON.parse(localStorage.getItem('moduleNames') || null);
    console.log('MenuResolver resolving:', { user, moduleNames });
    if (user  && window.location.pathname !== '/booking') { return this.graphQlService.setMenusByAllowedList(user.auth.data.userType, moduleNames); }
  }
}
